import { render, staticRenderFns } from "./SiteDetail.vue?vue&type=template&id=15d4fe8c&"
import script from "./SiteDetail.js?vue&type=script&lang=js&"
export * from "./SiteDetail.js?vue&type=script&lang=js&"
import style0 from "./SiteDetail.vue?vue&type=style&index=0&id=15d4fe8c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports